import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * VEZETŐ IKON a mező bal szélén (pl. a fájl-megosztási linkeknél a szolgáltatás jele).
   *
   * MIÉRT AZ ATOMON, ÉS NEM A HÍVÓNÁL: a burkoló markup (relatív konténer + absztolút, `pointer-events-none`
   * ikon + `pl-9` a mezőn) eddig a `form-fields.tsx` `TextField`-jében élt, tehát CSAK react-hook-form-hoz
   * kötött mezőn volt elérhető. A partner jegy-nyitója viszont RHF NÉLKÜLI `Input`-okat használ (lokális
   * `useState`), és ugyanezt a megjelenést kérte (user-döntés) — egy második, kézzel másolt
   * burkolat garantáltan elcsúszott volna (más `left`, más ikon-méret). A `TextField` mostantól ezt a propot
   * adja tovább, tehát a két felület BITRE ugyanazt rendereli.
   */
  leadingIcon?: React.ReactNode;
}

// Input: 32px magas, 8px rádiusz, 13.5px szöveg; fókusz = egyszerű, vékony SÖTÉT keret (nincs glow/dupla ring).
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, leadingIcon, ...props }, ref) => {
    const field = (
      <input
        type={type}
        ref={ref}
        className={cn(
          'border-border input-glass text-md ease-atlas flex h-8 w-full rounded-lg border px-2.5 py-1 transition-[border-color,box-shadow] duration-150',
          'file:text-md placeholder:text-subtle file:border-0 file:bg-transparent file:font-medium',
          // Fókusz: a közös `.input-glass:focus` CSS adja a halvány zöld ringet (egységes minden mezőn).
          'focus-visible:outline-none',
          'disabled:cursor-not-allowed disabled:opacity-50',
          // Az ikon helye: a szöveg-behúzás CSAK ikonnal (különben minden mező tolódna).
          leadingIcon !== undefined && 'pl-9',
          className,
        )}
        {...props}
      />
    );
    if (leadingIcon === undefined) return field;
    return (
      <div className="relative">
        <span
          aria-hidden="true"
          className="text-muted-foreground pointer-events-none absolute left-2.5 top-1/2 flex size-4 -translate-y-1/2 items-center justify-center"
        >
          {leadingIcon}
        </span>
        {field}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
